import React, { useState, useEffect } from "react";
import {
  Typography,
  FormLabel,
  Input,
  Paper,
  Box,
  TextField,
  TextareaAutosize,
  CardContent,
  CardActions,
  Card,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@material-ui/core";
import axios from "axios";
import envUrls from "../../../utils/config";
import { toast, ToastContainer } from "react-toastify";
import { css } from "@emotion/react";
import Preview from "../../previewPage/preview";
import "./comments.css";
const Comments = (props) => {
  console.log(props, "these are props");
  const [localComment, setLocalComment] = useState("");
  const comment =
    props.closingComment !== undefined ? props.closingComment : localComment;
  const setComment = props.setClosingComment || setLocalComment;
  const [attachment, setAttachment] = useState([]);
  const [attachmentPreviewUrls, setAttachmentPreviewUrls] = useState([]);
  const [modalAttachment, setModalAttachment] = useState([]);
  const [modalAttachmentPreviewUrls, setModalAttachmentPreviewUrls] = useState([]);
  const [localPreviewUrl, setLocalPreviewUrl] = useState(null);
  const [render, setrender] = useState("");
  const [btnDisable, setBtnDisable] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [isModalDragging, setIsModalDragging] = useState(false);
  const [isPasteActive, setIsPasteActive] = useState(false);
  const isZoneActive = isModalDragging || isPasteActive;
  // tracks which button triggered the in-flight request so only that
  // button shows the loading spinner ("comment" | "action")
  const [activeAction, setActiveAction] = useState(null);

  toast.configure();

  const notifyValidationsError = (msg) => {
    toast.error(msg, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 1000,
    });
  };
  const notifyValidationsWarns = (msg) => {
    toast.dismiss();
    toast.clearWaitingQueue();
    toast(msg, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 5000,
      className: css({
        backgroundColor: "red",
      }),
    });
  };

  function getCookie(name) {
    var found = document.cookie
      .split(";")
      .filter((c) => c.trim().split("=")[0] === name);
    return found.length > 0 ? found[0].split("=")[1] : null;
  }

  const notifyValidationsSuccess = (msg) =>
    toast.success(msg, {
      position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 10000000,
    });
  // notifyValidationsWarns('THIS IS THE ERROR')
  // toast.isActive()
  // console.log(toast.isActive())

  async function deleteFilesInS3(filePaths) {
    try {
      const params = new URLSearchParams();
      filePaths.forEach((path) => params.append("file_paths", path));
      const response = await axios.delete(
        `${envUrls.baseUrl}delete_files?${params}`
      );
      if (response.status === 200) {
        console.log(response);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const submitComment = (fileKeys) => {
    if (attachment.length < 1) {
      setBtnDisable(true);
    }
    // console.log(fileKeys);
    if (comment !== "") {
      const fd = new FormData();
      fd.set("issue_id", props.id);
      fd.set("timestamp", Date.now());
      fd.set("comment_msg", comment);
      fd.set("email", props.email);
      const params = new URLSearchParams();
      if (attachment.length > 0) {
        fileKeys.forEach((key) => {
          params.append("file_paths", key);
        });
      }
      axios
        .post(`${envUrls.baseUrl}comment?${params.toString()}`, fd)
        .then((res) => {
          console.log(res);
          const afterComment = props.onAfterCommentPosted
            ? props.onAfterCommentPosted()
            : Promise.resolve(false);
          return Promise.resolve(afterComment).then((handledWithoutReload) => {
            setComment("");
            setAttachment([]);
            setBtnDisable(false);
            if (!handledWithoutReload) {
              window.location.reload();
            }
          });
        })
        .catch((err) => {
          console.log(err);
          deleteFilesInS3(fileKeys);
          setBtnDisable(false);
          if (
            err.response.status == 401 &&
            sessionStorage.getItem("logging_out") !== "true"
          ) {
            window.location.href = "/login";
            notifyValidationsWarns("Session expired, Please login again");
            sessionStorage.setItem("session_expired", "true");
          }
        });
    } else {
      setBtnDisable(false);
      notifyValidationsWarns(
        "Please Add a Comment then press on Submit button"
      );
    }
  };

  function normalizeFilename(filename) {
    // Replace non-breaking spaces with regular spaces
    return filename.replace(/\u200B|\u00A0/g, " ").trim();
  }

  async function uploadFilesToS3() {
    const fileNames = attachment.map((file) => file.name);
    const email = getCookie("email_windbug");
    const timestamp = Date.now();
    const uploadType = "issue_file";
    console.log(email);
    const params = new URLSearchParams();

    fileNames.forEach((name) => params.append("file_names", name));
    params.append("email", email.replace(/"/g, ""));
    params.append("timestamp", timestamp);
    params.append("upload_type", uploadType);

    const url = `${envUrls.baseUrl}/get_presigned_urls?${params.toString()}`;
    // const url = "";
    try {
      const response = await axios.get(url);
      if (response.data) {
        const keys = [];
        console.log(response.data, "??????");
        const uploadPromises = response.data.map(async (data) => {
          console.log("first");

          const file = attachment.find((f) => f.name === data.file_name);
          if (!file) return;
          console.log(file);
          try {
            console.log("hey");
            await axios.put(data.presigned_url, file, {
              headers: {
                "Content-Type": "application/octet-stream",
              },
              withCredentials: true,
            });
            console.log(`File uploaded: ${file.name}`);
            keys.push(data.key);
          } catch (uploadError) {
            console.error(`Error uploading file: ${file.name}`, uploadError);
          }
        });
        console.log(uploadPromises);
        await Promise.all(uploadPromises);

        if (keys.length === response.data.length) {
          submitComment(keys);
          console.log(
            "All files uploaded successfully, proceeding to handleAddIssue."
          );
        } else {
          console.warn(
            "Not all files were uploaded successfully. Skipping handleAddIssue."
          );
          setBtnDisable(false);
        }

        console.log("All files uploaded successfully");
      }
    } catch (error) {
      console.error("Error getting presigned URLs:", error);
      notifyValidationsWarns(
        "Something went wrong while uploading the file(s)"
      );
      setBtnDisable(false);
    }
  }
  function handleSubmitComment() {
    if (comment === "") {
      notifyValidationsWarns(
        "Please Add a Comment then press on Submit button"
      );
      return;
    }
    setActiveAction("comment");
    setBtnDisable(true);
    if (attachment.length > 0) {
      uploadFilesToS3();
    } else {
      submitComment();
    }
  }

  const submitOpenCloseIssue = () => {
    if (comment !== "") {
      setActiveAction("action");
      setBtnDisable(true);
      const fd = new FormData(); 
      fd.set("issue_id", props.id);
      fd.set("timestamp", Date.now());
      fd.set("comment_msg", comment);
      fd.set("email", props.email);
      // fd.set('attachment', attachment)
      if (props.performActionStatus === "Close") {
        fd.set("close_by", props.email);
      } else {
        fd.set("reopen_by", props.email);
      }
      if (attachment) {
        for (var i = 0; i < attachment.length; i++) {
          console.log("present", attachment[i]);
          fd.append("attachment", attachment[i]);
        }
      }
      axios
        .post(envUrls.baseUrl + "comment", fd)
        .then((res) => {
          console.log(res.data.message, "yahan haui");

          if (res.data.message) {
            setBtnDisable(false);
            notifyValidationsWarns(res.data.message);
          } else {
            const targetStage =
              props.performActionStatus === "Close"
                ? "Stage 7 (Closed)"
                : "Stage 1";
            const stageFd = new FormData();
            stageFd.set("issue_id", props.id);
            stageFd.set("issue_stage", targetStage);
            return axios
              .post(envUrls.baseUrl + "update_issue", stageFd)
              .then(() => {
                if (props.onStageUpdated) {
                  props.onStageUpdated(targetStage);
                }
                return res;
              })
              .catch(() => {
                if (props.onStageUpdated) {
                  props.onStageUpdated(targetStage);
                }
                return res;
              });
          }
        })
        .then((res) => {
          if (!res) {
            return;
          }
          setComment("");
          if (props.performActionStatus === "Close") {
            toast("Case has been Closed", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 3000,
            });
            setTimeout(() => window.location.reload(), 3000);
          } else {
            toast("Case has been Reopened", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 3000,
            });
            setTimeout(() => window.location.reload(), 3000);
          }
        })
        .catch((err) => {
          console.log(err);
          setBtnDisable(false);
          if (
            err.response.status == 401 &&
            sessionStorage.getItem("logging_out") !== "true"
          ) {
            window.location.href = "/login";
            notifyValidationsWarns("Session expired, Please login again");
            sessionStorage.setItem("session_expired", "true");
          }
        });
    } else {
      notifyValidationsWarns(
        props.performActionStatus === "Close"
          ? "Please Add a Comment then press on close button"
          : "Please Add a Comment then press on reopen button"
      );
    }
  };

  const openFileInput = () => {
    setIsModalDragging(false);
    setIsPasteActive(false);
    setModalAttachment([...attachment]);
    setShowUploadModal(true);
  };

  const closeUploadModal = () => {
    setShowUploadModal(false);
    setIsModalDragging(false);
    setIsPasteActive(false);
  };

  const handleConfirmAttach = () => {
    setAttachment([...modalAttachment]);
    closeUploadModal();
  };

  const handleModalDragOver = (e) => {
    e.preventDefault();
    setIsModalDragging(true);
  };

  const handleModalDragLeave = () => setIsModalDragging(false);

  let fileTypeallowe = [
    "pdf",
    "jpg",
    "png",
    "docx",
    "jpeg",
    "ppt",
    "txt",
    "xls",
    "pptx",
    "xlsx",
    "xlsm",
    "ws3",
    "zip",
    "7z",
    "csv",
    "jam",
    "rtf",
    "tab",
    "kml",
    "kmz",
    "fig",
  ];
  const isAllowedFile = (f) =>
    f && f.name && fileTypeallowe.includes(f.name.toLowerCase().split(".").pop());

  const addModalFiles = (fileList) => {
    const incoming = Array.from(fileList);
    const currentCount = modalAttachment.length;
    if (currentCount >= 4) {
      notifyValidationsWarns("Maximum 4 files can be uploaded");
      return;
    }
    const slots = 4 - currentCount;
    const allowed = incoming.slice(0, slots).filter(isAllowedFile);
    const rejected = incoming.slice(0, slots).filter((f) => !isAllowedFile(f));
    if (rejected.length > 0) notifyValidationsWarns("File Type not allowed");
    if (allowed.length > 0)
      setModalAttachment((prev) => [...prev, ...allowed]);
    if (incoming.length > slots)
      notifyValidationsWarns("Maximum 4 files can be uploaded");
  };

  const addCommentFiles = (fileList) => {
    const incoming = Array.from(fileList);
    const currentCount = attachment.length;
    if (currentCount >= 4) {
      notifyValidationsWarns("Maximum 4 files can be uploaded");
      return;
    }
    const slots = 4 - currentCount;
    const allowed = incoming.slice(0, slots).filter(isAllowedFile);
    const rejected = incoming.slice(0, slots).filter((f) => !isAllowedFile(f));
    if (rejected.length > 0) notifyValidationsWarns("File Type not allowed");
    if (allowed.length > 0)
      setAttachment((prev) => [...prev, ...allowed]);
    if (incoming.length > slots)
      notifyValidationsWarns("Maximum 4 files can be uploaded");
  };

  const handleModalDrop = (e) => {
    e.preventDefault();
    setIsModalDragging(false);
    setIsPasteActive(false);
    if (e.dataTransfer && e.dataTransfer.files) {
      addModalFiles(e.dataTransfer.files);
    }
  };

  const handleModalPaste = (e) => {
    const clipboardData = e.clipboardData;
    if (!clipboardData) return;

    let incomingFiles = [];
    if (clipboardData.files && clipboardData.files.length > 0) {
      incomingFiles = Array.from(clipboardData.files);
    } else if (clipboardData.items && clipboardData.items.length > 0) {
      const fileItems = Array.from(clipboardData.items).filter(
        (it) => it.kind === "file"
      );
      incomingFiles = fileItems.map((it) => it.getAsFile()).filter(Boolean);
    }

    if (incomingFiles.length === 0) return;
    e.preventDefault();

    const normalizedFiles = incomingFiles.map((file) => {
      const ext =
        (file.type && file.type.split("/")[1]) ||
        file.name.split(".").pop() ||
        "png";
      const name =
        file.name && file.name !== "image.png" && file.name.trim() !== ""
          ? file.name
          : `screenshot-${Date.now()}.${ext}`;
      return new File([file], name, { type: file.type });
    });

    addModalFiles(normalizedFiles);
    setIsPasteActive(false);
  };

  const handleFile = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;
    if (showUploadModal) {
      addModalFiles(files);
    } else {
      addCommentFiles(files);
    }
    event.target.value = null;
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
    if (event.dataTransfer && event.dataTransfer.files) {
      addCommentFiles(event.dataTransfer.files);
    }
  };
  console.log(attachment);
  let deletefileinput = (event, i) => {
    // incomplete for now
    console.log(i, attachment);
    setAttachment(attachment.filter((_, id) => id != i));
  };

  const deleteModalFileInput = (event, i) => {
    setModalAttachment((prev) => prev.filter((_, id) => id !== i));
  };

  useEffect(() => {
    const urls = modalAttachment.map((file) =>
      file && file.type && file.type.startsWith("image/")
        ? URL.createObjectURL(file)
        : null
    );
    setModalAttachmentPreviewUrls(urls);
    return () => {
      urls.forEach((url) => url && URL.revokeObjectURL(url));
    };
  }, [modalAttachment]);

  useEffect(() => {
    const urls = attachment.map((file) =>
      file && file.type && file.type.startsWith("image/")
        ? URL.createObjectURL(file)
        : null
    );
    setAttachmentPreviewUrls(urls);
    return () => {
      urls.forEach((url) => url && URL.revokeObjectURL(url));
    };
  }, [attachment]);

  return (
    <Card
      elevation={3}
      style={{ marginLeft: "9px", marginBottom: "10px", marginTop: "10px" }}
    >
      {/* <div style={{ borderBottom: 'solid 3px lightgrey', width: '50%', marginLeft: '25%', marginTop: 17 }}></div> */}
      <div
        className="main_class"
        style={{
          padding: 10,
          marginTop: "10px",
          border: isDragging ? "2px dashed #004AAD" : "2px dashed transparent",
          backgroundColor: isDragging ? "rgba(0, 74, 173, 0.05)" : "transparent",
          borderRadius: "8px",
          transition: "border 0.15s ease, background-color 0.15s ease",
        }}
        onDragOver={handleDragOver}
        onDragEnter={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <Typography
          style={{ fontWeight: 500, fontSize: "15px" }}
          variant="h5"
          gutterBottom
        >
          Closing/Re-opening Comment
        </Typography>
        <TextareaAutosize
          maxRows={11}
          minRows={10}
          mincols={100}
          aria-label="maximum height"
          placeholder="Type your additional/closing/reopening comment here"
          style={{ width: "600px", padding: "20px", height: 120 }}
          value={comment}
          onChange={(e) => {
            setComment(e.target.value);
          }}
          onPaste={(e) => {
            const clipboardData = e.clipboardData;
            if (!clipboardData) return;

            let incomingFiles = [];
            if (clipboardData.files && clipboardData.files.length > 0) {
              incomingFiles = Array.from(clipboardData.files);
            } else if (clipboardData.items && clipboardData.items.length > 0) {
              const fileItems = Array.from(clipboardData.items).filter(
                (it) => it.kind === "file"
              );
              incomingFiles = fileItems.map((it) => it.getAsFile()).filter(Boolean);
            }

            if (incomingFiles.length === 0) return;
            e.preventDefault();

            const normalizedFiles = incomingFiles.map((file) => {
              const ext =
                (file.type && file.type.split("/")[1]) ||
                file.name.split(".").pop() ||
                "png";
              const name =
                file.name && file.name !== "image.png" && file.name.trim() !== ""
                  ? file.name
                  : `screenshot-${Date.now()}.${ext}`;
              return new File([file], name, { type: file.type });
            });

            addCommentFiles(normalizedFiles);
          }}
        />
        {attachment.length === 0 && (
          <Typography
            variant="caption"
            style={{ display: "block", color: "#8B8B8B", marginTop: "4px" }}
          >
            {isDragging
              ? "Release to attach file"
              : "Drag and drop a file here, or use Attach File below"}
          </Typography>
        )}
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {attachment.map((val, i) => (
            <p key={i} style={{ marginLeft: "8px", marginRight: "8px" }}>
              {val.name}{" "}
              <i
                className="fa fa-trash text-danger"
                style={{ fontSize: "18px", marginLeft: "5px", cursor: "pointer" }}
                onClick={deletefileinput.bind(null, val, i)}
              ></i>{" "}
            </p>
          ))}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "50%",
            height: 50,
            alignItems: "center",
            marginTop: "10px",
          }}
        >
          {/* <Button variant="contained" color="primary" disabled={props.email !== props.issuerEmail && props.email !== 'tilak@sirpi.io'} style={{ marginLeft: '20px', marginTop: '5px' }} onClick={submitOpenCloseIssue}>
                {props.performActionStatus} Issue
            </Button> */}
          <Button
            className={
              btnDisable || props.stageApiLoading ? "dis_butt" : ""
            }
            disabled={btnDisable || !!props.stageApiLoading}
            variant="contained"
            size="small"
            style={{
              borderRadius: "10px",
              backgroundColor: "#004AAD",
              color: "white",
              textTransform: "none",
            }}
            onClick={openFileInput}
          >
            Attach File
          </Button>
          <input
            type="file"
            style={{ display: "none" }}
            id="fileupload"
            multiple={true}
            onChange={handleFile}
          />
          <Button
            className={
              activeAction === "comment" ||
              btnDisable ||
              props.stageApiLoading ||
              props.pendingStage === "Stage 7 (Closed)" ||
              props.selectedStage === "Stage 7 (Closed)"
                ? "dis_butt"
                : ""
            }
            disabled={
              btnDisable ||
              !!props.stageApiLoading ||
              props.pendingStage === "Stage 7 (Closed)" ||
              props.selectedStage === "Stage 7 (Closed)"
            }
            size="small"
            variant="contained"
            onClick={handleSubmitComment}
            style={{
              borderRadius: "10px",
              backgroundColor: "#004AAD",
              color: "white",
              textTransform: "none",
            }}
          >
            Submit
            {btnDisable && activeAction === "comment" && (
              <CircularProgress
                style={{ color: "white", marginLeft: "5px" }}
                size={20}
              />
            )}
          </Button>
          <Button
            className={
              activeAction === "action" || btnDisable || props.stageApiLoading
                ? "dis_butt"
                : ""
            }
            disabled={btnDisable || !!props.stageApiLoading}
            size="small"
            variant="contained"
            onClick={submitOpenCloseIssue}
            style={{
              borderRadius: "10px",
              backgroundColor: "#004AAD",
              color: "white",
              textTransform: "none",
            }}
          >
            {props.performActionStatus} {props.fileType}
            {btnDisable && activeAction === "action" && (
              <CircularProgress
                style={{ color: "white", marginLeft: "5px" }}
                size={20}
              />
            )}
          </Button>
          <ToastContainer limit={1} />
        </div>
      </div>

      {/* ── Attach File(s) Modal ── */}
      {showUploadModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            display: localPreviewUrl ? "none" : "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(0,0,0,0.45)",
          }}

        >
          <div
            style={{
              background: "#fff",
              borderRadius: "16px",
              padding: "32px 36px 28px",
              width: "480px",
              maxWidth: "95vw",
              boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
              fontFamily: "Jost, sans-serif",
              position: "relative",
            }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 20,
              }}
            >
              <span
                style={{
                  fontSize: "1.15rem",
                  fontWeight: 600,
                  color: "#002960",
                }}
              >
                Attach File(s)
              </span>
              <button
                onClick={closeUploadModal}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "1.4rem",
                  cursor: "pointer",
                  color: "#8B8B8B",
                  lineHeight: 1,
                }}
                title="Close"
              >
                ×
              </button>
            </div>

            {/* Drag & Drop / Paste zone */}
            <div
              tabIndex={0}
              onClick={() => setIsPasteActive(true)}
              onFocus={() => setIsPasteActive(true)}
              onBlur={(e) => {
                if (!e.currentTarget.contains(e.relatedTarget)) {
                  setIsPasteActive(false);
                }
              }}
              onDragOver={handleModalDragOver}
              onDragLeave={handleModalDragLeave}
              onDrop={handleModalDrop}
              onPaste={handleModalPaste}
              style={{
                border: `2px dashed ${isZoneActive ? "#1557B0" : "#C4C4C4"}`,
                borderRadius: "12px",
                background: isZoneActive ? "#EEF4FF" : "#FAFAFA",
                padding: "36px 24px",
                textAlign: "center",
                cursor: "pointer",
                outline: "none",
                transition: "border-color 0.2s, background 0.2s",
                marginBottom: 20,
              }}
            >
              <i
                className="fa fa-cloud-upload"
                style={{
                  fontSize: "2.8rem",
                  color: isZoneActive ? "#1557B0" : "#C4C4C4",
                  marginBottom: 12,
                  display: "block",
                  transition: "color 0.2s",
                }}
              ></i>
              <p
                style={{
                  fontWeight: 600,
                  fontSize: "1rem",
                  color: isZoneActive ? "#002960" : "#333",
                  marginBottom: 6,
                  transition: "color 0.2s",
                }}
              >
                Drag &amp; Drop or Paste your file here
              </p>
              <p
                style={{
                  fontSize: "0.82rem",
                  color: isZoneActive ? "#1557B0" : "#8B8B8B",
                  marginBottom: 0,
                  transition: "color 0.2s",
                }}
              >
                Drop file into this area &nbsp;·&nbsp; or press&nbsp;
                <kbd
                  style={{
                    background: isZoneActive ? "#ffffff" : "#f0f0f0",
                    border: isZoneActive ? "1px solid #90caf9" : "none",
                    borderRadius: 4,
                    padding: "1px 5px",
                    fontSize: "0.78rem",
                    color: isZoneActive ? "#1557B0" : "inherit",
                  }}
                >
                  Ctrl+V
                </kbd>
                &nbsp;/&nbsp;
                <kbd
                  style={{
                    background: isZoneActive ? "#ffffff" : "#f0f0f0",
                    border: isZoneActive ? "1px solid #90caf9" : "none",
                    borderRadius: 4,
                    padding: "1px 5px",
                    fontSize: "0.78rem",
                    color: isZoneActive ? "#1557B0" : "inherit",
                  }}
                >
                  Cmd+V
                </kbd>
                &nbsp;to paste a file or screenshot
              </p>
            </div>

            {/* Divider */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 20,
              }}
            >
              <div style={{ flex: 1, height: 1, background: "#E0E0E0" }} />
              <span style={{ color: "#8B8B8B", fontSize: "0.82rem" }}>or</span>
              <div style={{ flex: 1, height: 1, background: "#E0E0E0" }} />
            </div>

            {/* Browse button */}
            <div style={{ textAlign: "center" }}>
              <button
                onClick={() => {
                  const input = document.getElementById("fileupload");
                  if (input) input.click();
                }}
                style={{
                  background:
                    "linear-gradient(97.88deg, #002960 -4.13%, #1557B0 102.47%)",
                  color: "#fff",
                  border: "none",
                  borderRadius: "10px",
                  padding: "10px 32px",
                  fontFamily: "Jost",
                  fontSize: "0.95rem",
                  fontWeight: 600,
                  cursor: "pointer",
                  letterSpacing: "0.3px",
                }}
              >
                <i
                  className="fa fa-folder-open"
                  style={{ marginRight: 8 }}
                ></i>
                Browse Files
              </button>
              <p
                style={{
                  marginTop: 10,
                  fontSize: "0.76rem",
                  color: "red",
                  lineHeight: 1.45,
                  maxWidth: "420px",
                  margin: "10px auto 0",
                }}
              >
                Max 4 files * &nbsp;·&nbsp; Allowed: pdf, jpg, jpeg, png, docx, ppt, pptx, xls, xlsx, xlsm, txt, csv, zip, 7z, ws3, jam, rtf, tab, kml, kmz, fig.
              </p>
            </div>

            {/* ── Attached files list inside modal ── */}
            {modalAttachment.length > 0 && (
              <div
                style={{
                  marginTop: 18,
                  paddingTop: 14,
                  borderTop: "1px solid #EAEAEA",
                  textAlign: "left",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 8,
                  }}
                >
                  <span
                    style={{
                      fontSize: "0.85rem",
                      fontWeight: 600,
                      color: "#002960",
                    }}
                  >
                    Attached Files ({modalAttachment.length}/4):
                  </span>
                </div>
                <div
                  style={{
                    maxHeight: "130px",
                    overflowY: "auto",
                    paddingRight: 4,
                  }}
                >
                  {Array.from(modalAttachment).map((elm, ind) => (
                    <div
                      key={ind}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        background: "#F8F9FA",
                        border: "1px solid #E9ECEF",
                        borderRadius: "8px",
                        padding: "6px 12px",
                        marginBottom: 6,
                        fontSize: "0.82rem",
                        color: "#333",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          marginRight: 10,
                        }}
                      >
                        <span
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          title={elm.name}
                        >
                          {ind + 1}. {elm.name}
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexShrink: 0,
                        }}
                      >
                        {modalAttachmentPreviewUrls[ind] && (
                          <i
                            className="fa fa-eye"
                            title="Preview"
                            style={{
                              fontSize: "16px",
                              marginLeft: "10px",
                              color: "#1557B0",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              setLocalPreviewUrl(
                                modalAttachmentPreviewUrls[ind]
                              )
                            }
                          ></i>
                        )}
                        <i
                          className="fa fa-trash text-danger"
                          title="Delete"
                          style={{
                            fontSize: "16px",
                            marginLeft: "12px",
                            cursor: "pointer",
                          }}
                          onClick={deleteModalFileInput.bind(null, elm, ind)}
                        ></i>
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ textAlign: "center", marginTop: 14 }}>
                  <button
                    onClick={handleConfirmAttach}
                    style={{
                      background: "#002960",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "8px 28px",
                      fontFamily: "Jost",
                      fontSize: "0.9rem",
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                  >
                    Attach
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {localPreviewUrl && (
        <Preview
          open={true}
          close={() => setLocalPreviewUrl(null)}
          url={localPreviewUrl}
        />
      )}
    </Card>
  );
};

export default Comments;
